export const UpdateShippingAddress = "a56679980c6be32d734d99d7e0b3ead2803dc975c52bfd65a454fa57775d921e";